import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-status-cell',
  templateUrl: './status-cell.component.html',
  styleUrls: ['./status-cell.component.scss']
})
export class StatusCellComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;
  public value: number = 0;
  public environment: string = '';

  public changed: boolean = false;
  public sync: boolean = false;
  public bhs_imageSync: boolean = false;
  public mws_imageSync: boolean = false;
  public confirmed: boolean = false;
  public waitingApproval: boolean = false;
  public disapproved: boolean = false;
  public error: boolean = false;
  public delete: boolean = false;
  public conflict: boolean = false;
  public pendingSync: boolean = false;
  public syncError: boolean = false;
  public syncErrorMessage: string = '';
  public mws_syncErrorMessage: string = '';
  public syncInProgress: boolean = false;
  public successfullyDeleted: boolean = false;

  public edited: boolean = false;
  public editorName: string = '';

  public new: boolean = false;
  public mws_new: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.environment = params.data.environment;
    this.new = params.data.new;
    this.mws_new = params.data.mws_new;
    this.delete = params.data.delete;
    this.successfullyDeleted = !!params.data.successfullyDeleted;
    this.value = this.params.value;
    this.edited = this.params.data.locked !== undefined;
    this.syncErrorMessage = this.params.data.syncErrorMessage;
    this.mws_syncErrorMessage = this.params.data.mws_syncErrorMessage;

    this.confirmed = this.value === 30;
    this.changed = this.value === 20 && ['production'].includes(this.environment);
    this.waitingApproval = ['changes', 'stage'].includes(this.environment) && this.value === 20;
    this.conflict = this.value === 50;
    this.sync = this.value === 10;
    this.disapproved = this.value === 40;
    this.pendingSync = this.value === 60;
    this.syncInProgress = this.value === 70;
    this.syncError = this.value === 80;
    this.bhs_imageSync = this.value === 12;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  onDragStart(event: DragEvent, str: string) {
    event.dataTransfer!.setData(
      'text/plain',
      'Dragged item with ID: ' + str
    );
    console.log('onDragStart', event);
  }
}
